import { render, staticRenderFns } from "./FilterPills.vue?vue&type=template&id=527af779"
import script from "./FilterPills.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterPills.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports